import React from 'react';

const ReviewCard = ({ author, text, rating }) => {
  // Helper function to generate star icons or text based on rating
  const renderRating = (rate) => {
    if (typeof rate === 'number' && rate >= 0 && rate <= 5) {
      const stars = [];
      for (let i = 1; i <= 5; i++) {
        stars.push(
          <span key={i} className={i <= rate ? "text-yellow-400" : "text-gray-300"}>
            &#9733; {/* Filled star */}
          </span>
        );
      }
      return <div className="flex items-center">{stars} <span className="ml-1 text-xs text-gray-500 md:ml-2 md:text-sm md:text-gray-600">({rate}/5)</span></div>;
    }
    return <span className="text-sm text-gray-600">{rating}</span>; // Fallback for non-standard rating
  };

  return (
    <div className="bg-white p-4 rounded-xl shadow-lg border border-gray-200 w-full min-w-[280px] sm:min-w-[320px] md:p-6 md:max-w-md flex flex-col">
      <p className="text-gray-700 text-sm mb-3 flex-grow md:text-base md:mb-4">
        "{text}"
      </p>
      <div className="flex items-center justify-between mt-auto pt-3"> {/* Added mt-auto and pt-3 for spacing */}
        <p className="text-stone-800 font-semibold text-xs md:text-sm">- {author}</p>
        {renderRating(rating)}
      </div>
      {/* Example of Swedish text, if needed for other elements */}
      {/* <p className="text-xs text-gray-500 mt-2">Recension</p> */}
    </div>
  );
};

export default ReviewCard;
